import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  excellence: drilldownData["excellence"].map(
    ({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
    })
  ),
  addcontactdirectory: drilldownData["addcontactdirectory"].map(
    ({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
    })
  ),
  operation: drilldownData["operation"].map(
    ({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
    })
  ),
  CposOffice: drilldownData["CposOffice"].map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions,options }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions: loadOptions,
      options:options
    })
  ),
};
